export const AuctionStatus = {
  Unscheduled: 0,
  Scheduled: 1,
  Live: 2,
  Ended: 3,
  Rejected: 4,
  Stopped: 5,
}
